import { BROKER_PORTAL_THEMES, S3_BUCKET_URL } from "../constants";
import tinycolor from "tinycolor2";
import ImgLogoAsset from "@Shared/@Assets/img/logo.png";
import ImgLogoAssetFr from "@Shared/@Assets/img/Filogix_CA_Logo_RGB-01.png";
import { trim } from "lodash";
import i18n from "@Shared/@i18n/index";
export const hslColour = (hex, percentage) => {
  const colour = tinycolor(hex);
  const {
    r,
    g,
    b
  } = colour.toRgb();
  //TODO: need to do something about this import for broker/client classes
  //eslint-disable-next-line no-undef
  const hsl = new ThemeActions().rgbToHsl(r, g, b);
  return `hsl(${hsl.h},${hsl.s}%,${percentage}%)`;
};
export const checkedThemeOption = (theme, currentPrimary, currentSecondary) => {
  const currentTheme = BROKER_PORTAL_THEMES[theme];
  let isATheme = false;
  if (theme === "own") {
    for (let key in BROKER_PORTAL_THEMES) {
      const {
        primary,
        secondary
      } = BROKER_PORTAL_THEMES[key];
      if (primary === currentPrimary && secondary === currentSecondary) isATheme = true;
    }
  }
  if (theme === "own" && !isATheme) return true;
  if (theme === "own") return false;
  const {
    primary,
    secondary
  } = currentTheme;
  if (primary === currentPrimary && secondary === currentSecondary) return true;
};
export const getSecondaryComplement = () => {
  const bodyStyles = window.getComputedStyle(document.body);
  const secondaryColor = trim(bodyStyles.getPropertyValue("--secondary"));
  return tinycolor(secondaryColor).complement().toHexString();
};
export const getLogo = subdomain => {
  const path = window.location.pathname.replace("/", "").replace("#", "");
  const subdomainToUse = subdomain || path;
  const time = new Date().getTime();
  const url = `${S3_BUCKET_URL}/portal-styles/${subdomainToUse}?${time}`;
  if (subdomainToUse) return `${url}`;
  return i18n.locale === "fr-CA" ? ImgLogoAssetFr : ImgLogoAsset;
};
export const getCurrentColours = () => {
  const bodyStyles = window.getComputedStyle(document.body);
  const primary = trim(bodyStyles.getPropertyValue("--primary"));
  const secondary = trim(bodyStyles.getPropertyValue("--secondary"));
  const primaryAlt = trim(bodyStyles.getPropertyValue("--primary-alt"));
  const primaryRGB = trim(bodyStyles.getPropertyValue("--primary-rgb"));
  const primaryClear = trim(bodyStyles.getPropertyValue("--primary-clear"));
  return {
    primary,
    secondary,
    primaryAlt,
    primaryRGB,
    primaryClear
  };
};
export const removeColours = () => {
  document.documentElement.style.setProperty("--primary", "");
  document.documentElement.style.setProperty("--primary-alt", "");
  document.documentElement.style.setProperty("--primary-rgb", "");
  document.documentElement.style.setProperty("--primary-clear", "");
  document.documentElement.style.setProperty("--secondary", "");
  let idx = 1;
  for (let i = 95; i >= 50; i = i - 10) {
    document.documentElement.style.setProperty(`--primary-${idx}`, "");
    idx++;
    if (idx === 4 || idx === 5) i += 5;
  }
};
export const registerHandlebarHelpers = _Handlebars => {
  _Handlebars.registerHelper("hslColour", hslColour);
  _Handlebars.registerHelper("checkedThemeOption", checkedThemeOption);
  _Handlebars.registerHelper("getSecondaryComplement", getSecondaryComplement);
  _Handlebars.registerHelper("getLogo", getLogo);
};